module.exports = {"130123001":"诸福屯街道","130123002":"三里屯街道","130123100":"正定镇","130123102":"新城铺镇","130123103":"新安镇","130123104":"南岗镇","130123105":"曲阳桥镇","130123200":"南牛乡","130123201":"南楼乡","130123202":"西平乐乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130123.json
// module id = 151
// module chunks = 0